import { render, staticRenderFns } from "./equipmenTable.vue?vue&type=template&id=10612164&scoped=true"
import script from "./equipmenTable.vue?vue&type=script&lang=js"
export * from "./equipmenTable.vue?vue&type=script&lang=js"
import style0 from "./equipmenTable.vue?vue&type=style&index=0&id=10612164&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10612164",
  null
  
)

export default component.exports